import React from "react";

function TableEmpty(props) {
  const { children, ...otherProps } = props;

  return <tbody {...otherProps}>{children}</tbody>;
}

export default TableEmpty;
